import React from "react";
import { useNavigate } from "react-router-dom";
import { Space } from "antd";

import * as Common from "../commons/common";

function LayoutFooter() {
    const navigate = useNavigate();
    return (
        <Space
            direction="vertical"
            size={10}
            style={{
                backgroundColor: "black",
                color: "white",
                padding: "50px 16px",
                marginTop: "14px",
            }}
        >
            <div>
                <p style={{ fontSize: "18px", fontWeight: "900" }}>주식회사 루타스</p>
                <hr style={{ height: "0.4px" }} />
            </div>
            <p>대표 : 허성만 | 공장 : 대구광역시 달성군 구지면 국가산단서로71길 81, D동 | 사업자등록번호 : 362-81-01755</p>
            <p>개발자 이름 : RUTAS | 이메일 : support@rutas.co.kr</p>
            <Space>
                <a style={{ color: "#ffcc00" }} onClick={() => navigate(Common.PAGE_TOS)}>
                    이용약관
                </a>
                |
                <a style={{ color: "#ffcc00" }} onClick={() => window.open("https://ruta40.co.kr/privacypolicy", "_blank", "noopener, noreferrer")}>
                    개인정보처리방침
                </a>
            </Space>
        </Space>
    );
}

export default LayoutFooter;
